import { makeStyles } from '@material-ui/core/styles';

const useDigitalMediaStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    color: '#e9f0f7',
    background:
      'radial-gradient(circle at 10% 10%, rgba(0, 212, 170, 0.16) 0, transparent 28%), radial-gradient(circle at 90% 0%, rgba(102, 126, 234, 0.14) 0, transparent 28%), linear-gradient(180deg, #06111f 0%, #0c1728 34%, #07101d 100%)',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage:
        'linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)',
      backgroundSize: '80px 80px',
      maskImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.8), transparent 85%)',
      pointerEvents: 'none',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(circle at 50% 100%, rgba(0, 212, 170, 0.08), transparent 40%)',
      pointerEvents: 'none',
    },
  },

  pageContainer: {
    position: 'relative',
    zIndex: 1,
    paddingTop: theme.spacing(14),
    paddingBottom: theme.spacing(12),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(12),
      paddingBottom: theme.spacing(8),
    },
  },

  heroSection: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    position: 'relative',
  },

  heroEyebrow: {
    background: 'rgba(0, 212, 170, 0.12) !important',
    color: '#79f7de !important',
    border: '1px solid rgba(0, 212, 170, 0.25)',
    fontWeight: 800,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '999px',
    marginBottom: theme.spacing(2),
  },

  heroTitle: {
    margin: '0 auto',
    maxWidth: 'max-content',
    fontFamily: '"vester-poster", "Montserrat", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.04em',
    lineHeight: 0.95,
    fontSize: '4.4rem',
    background: 'linear-gradient(135deg, #ffffff 0%, #cdfaf1 45%, #6fe9d6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
      fontSize: '2.8rem',
      lineHeight: 1.02,
    },
  },

  heroDescription: {
    marginTop: theme.spacing(2.5),
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 680,
    fontSize: '1.08rem',
    lineHeight: 1.8,
    color: '#b5c3d3',
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  heroActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0,
    marginTop: theme.spacing(3),
    justifyContent: 'center',
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      '& > * + *': {
        marginLeft: theme.spacing(0.75),
      },
    },
  },

  primaryHeroButton: {
    background: 'linear-gradient(135deg, #00d4aa 0%, #00f0c8 48%, #19b7e6 100%)',
    color: '#06111f !important',
    padding: theme.spacing(1.6, 3),
    borderRadius: '14px',
    fontWeight: 800,
    textTransform: 'none',
    letterSpacing: '0.02em',
    boxShadow: '0 18px 45px rgba(0, 212, 170, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #00e0b7 0%, #39f5d0 48%, #32c0ee 100%)',
      boxShadow: '0 24px 60px rgba(0, 212, 170, 0.38)',
      transform: 'translateY(-2px)',
    },
  },

  secondaryHeroButton: {
    color: '#dfe8f2 !important',
    borderColor: 'rgba(233, 240, 247, 0.26) !important',
    padding: theme.spacing(1.6, 3),
    borderRadius: '14px',
    fontWeight: 700,
    textTransform: 'none',
    marginLeft: 0,
    '&:hover': {
      borderColor: 'rgba(0, 212, 170, 0.55) !important',
      background: 'rgba(0, 212, 170, 0.07) !important',
    },
  },

  heroPanel: {
    background: 'linear-gradient(180deg, rgba(10, 23, 41, 0.94) 0%, rgba(8, 16, 30, 0.9) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '24px',
    padding: theme.spacing(3.5),
    boxShadow: '0 30px 90px rgba(0, 0, 0, 0.35)',
    backdropFilter: 'blur(18px)',
    height: '100%',
  },

  heroPanelChip: {
    background: 'rgba(0, 212, 170, 0.14) !important',
    color: '#79f7de !important',
    border: '1px solid rgba(0, 212, 170, 0.24)',
    fontWeight: 800,
    marginBottom: theme.spacing(2),
  },

  heroPanelTitle: {
    marginBottom: theme.spacing(1.5),
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
    fontWeight: 700,
    lineHeight: 1.18,
    color: '#f5fbff',
    fontSize: '2rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.65rem',
    },
  },

  heroPanelText: {
    marginBottom: theme.spacing(2.5),
    color: '#bdd0e0',
    lineHeight: 1.75,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  heroSupportList: {
    display: 'grid',
    gap: theme.spacing(1.4),
  },

  heroSupportItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.6),
  },

  heroSupportDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginTop: 7,
    marginRight: theme.spacing(0.2),
    background: 'linear-gradient(135deg, #00d4aa 0%, #19b7e6 100%)',
    boxShadow: '0 0 16px rgba(0, 212, 170, 0.4)',
    flexShrink: 0,
  },

  heroSupportText: {
    color: '#edf4fb',
    fontWeight: 600,
    lineHeight: 1.5,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  statsGrid: {
    marginTop: theme.spacing(8),
  },

  statCard: {
    height: '100%',
    borderRadius: '22px',
    padding: theme.spacing(2.5),
    background: 'linear-gradient(180deg, rgba(11, 23, 41, 0.86) 0%, rgba(8, 16, 30, 0.76) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 18px 42px rgba(0, 0, 0, 0.18)',
    backdropFilter: 'blur(14px)',
    transition: 'transform 240ms ease, box-shadow 240ms ease, border-color 240ms ease',
    '&:hover': {
      transform: 'translateY(-6px)',
      borderColor: 'rgba(0, 212, 170, 0.28)',
      boxShadow: '0 24px 60px rgba(0, 0, 0, 0.26)',
    },
  },

  statValue: {
    fontFamily: '"vester-poster", "Montserrat", sans-serif',
    fontSize: '2.2rem',
    lineHeight: 1,
    fontWeight: 800,
    color: '#f8fdff',
    marginBottom: theme.spacing(1),
  },

  statLabel: {
    fontSize: '0.82rem',
    fontWeight: 800,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#8fd7cd',
    marginBottom: theme.spacing(0.8),
  },

  statNote: {
    fontSize: '0.95rem',
    lineHeight: 1.5,
    color: '#aebdcc',
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  tabsSection: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(10),
  },

  sectionHeading: {
    maxWidth: 900,
    marginBottom: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  sectionEyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.55, 1.4),
    borderRadius: '999px',
    border: '1px solid rgba(0, 212, 170, 0.22)',
    background: 'rgba(0, 212, 170, 0.08)',
    color: '#82f8e0 !important',
    fontWeight: 800,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1.5),
  },

  sectionTitle: {
    margin: 0,
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
    fontWeight: 800,
    lineHeight: 1.08,
    color: '#f8fdff',
    letterSpacing: '-0.03em',
    fontSize: '3rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.1rem',
    },
  },

  sectionDescription: {
    marginTop: theme.spacing(1.4),
    color: '#b5c3d3',
    lineHeight: 1.8,
    maxWidth: 'max-content',
    fontSize: '1.02rem',
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  tabsShell: {
    position: 'sticky',
    top: theme.spacing(11),
    zIndex: 4,
    padding: theme.spacing(1),
    marginBottom: theme.spacing(3),
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    background: 'rgba(6, 13, 24, 0.72)',
    backdropFilter: 'blur(18px)',
    boxShadow: '0 20px 48px rgba(0, 0, 0, 0.24)',
  },

  tabs: {
    minHeight: 'auto',
    '& .MuiTabs-indicator': {
      height: 3,
      borderRadius: 999,
      background: 'linear-gradient(90deg, #00d4aa 0%, #19b7e6 100%)',
    },
  },

  tab: {
    textTransform: 'none',
    minHeight: 58,
    minWidth: 'auto',
    marginRight: theme.spacing(0.75),
    borderRadius: '14px',
    color: '#a7b7c9 !important',
    transition: 'background 220ms ease, color 220ms ease, transform 220ms ease',
    '&.Mui-selected': {
      color: '#f8fdff !important',
      background: 'rgba(0, 212, 170, 0.12)',
    },
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.04)',
      transform: 'translateY(-1px)',
    },
  },

  tabLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    whiteSpace: 'nowrap',
    fontWeight: 700,
  },

  tabIcon: {
    fontSize: '1.05rem',
    lineHeight: 1,
  },

  tabContent: {
    position: 'relative',
  },

  categoryIntroCard: {
    position: 'sticky',
    top: theme.spacing(19),
    background: 'linear-gradient(180deg, rgba(13, 27, 47, 0.96) 0%, rgba(8, 17, 31, 0.93) 100%)',
    borderRadius: '24px',
    border: '1px solid rgba(255, 255, 255, 0.09)',
    padding: theme.spacing(3),
    boxShadow: '0 24px 70px rgba(0, 0, 0, 0.28)',
    backdropFilter: 'blur(16px)',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: 'auto',
    },
  },

  categoryChip: {
    background: 'rgba(0, 212, 170, 0.12) !important',
    color: '#86f8e1 !important',
    border: '1px solid rgba(0, 212, 170, 0.22)',
    fontWeight: 800,
    marginBottom: theme.spacing(2),
  },

  categoryTitle: {
    margin: 0,
    color: '#f8fdff',
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
    fontWeight: 800,
    lineHeight: 1.08,
    fontSize: '2.1rem',
  },

  categoryDescription: {
    marginTop: theme.spacing(1.5),
    color: '#b5c3d3',
    lineHeight: 1.8,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  categoryStats: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2.5),
  },

  categoryStat: {
    padding: theme.spacing(1.8),
    borderRadius: '18px',
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.03) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },

  categoryStatNote: {
    display: 'block',
    marginTop: theme.spacing(0.5),
    color: '#92a8bb',
    fontSize: '0.8rem',
    lineHeight: 1.4,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },

  categoryDivider: {
    margin: theme.spacing(2.5, 0),
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },

  summaryListHeading: {
    color: '#f8fdff',
    fontWeight: 800,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1.5),
  },

  categoryHighlightsList: {
    display: 'grid',
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(2.75),
  },

  highlightItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },

  highlightDot: {
    width: 9,
    height: 9,
    marginTop: 7,
    borderRadius: '50%',
    flexShrink: 0,
    background: 'linear-gradient(135deg, #00d4aa 0%, #19b7e6 100%)',
    boxShadow: '0 0 14px rgba(0, 212, 170, 0.35)',
  },

  highlightText: {
    color: '#edf4fb',
    lineHeight: 1.55,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  categoryCtaButton: {
    marginTop: 'auto',
    background: 'linear-gradient(135deg, #00d4aa 0%, #00f0c8 48%, #19b7e6 100%)',
    color: '#06111f !important',
    fontWeight: 800,
    padding: theme.spacing(1.5, 2.5),
    borderRadius: '14px',
    textTransform: 'none',
    boxShadow: '0 18px 45px rgba(0, 212, 170, 0.28)',
    '&:hover': {
      boxShadow: '0 24px 55px rgba(0, 212, 170, 0.36)',
      transform: 'translateY(-2px)',
    },
  },

  serviceCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.8),
    padding: theme.spacing(2.5),
    borderRadius: '22px',
    background: 'linear-gradient(180deg, rgba(13, 27, 47, 0.92) 0%, rgba(8, 17, 31, 0.88) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 20px 48px rgba(0, 0, 0, 0.22)',
    backdropFilter: 'blur(14px)',
    transition: 'transform 240ms ease, box-shadow 240ms ease, border-color 240ms ease',
    '&:hover': {
      transform: 'translateY(-8px)',
      borderColor: 'rgba(0, 212, 170, 0.24)',
      boxShadow: '0 28px 70px rgba(0, 0, 0, 0.3)',
    },
  },

  serviceCardTop: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.25),
  },

  serviceCategoryTag: {
    alignSelf: 'flex-start',
    background: 'rgba(255, 255, 255, 0.06) !important',
    color: '#bcefea !important',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    fontWeight: 700,
    fontSize: '0.72rem',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },

  serviceTitle: {
    color: '#f8fdff',
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: '1.25rem',
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
  },

  serviceDescription: {
    color: '#b5c3d3',
    lineHeight: 1.75,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  serviceMetaRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1.2),
  },

  serviceMetaCard: {
    padding: theme.spacing(1.4),
    borderRadius: '16px',
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.03) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },

  serviceMetaLabel: {
    display: 'block',
    marginBottom: theme.spacing(0.4),
    color: '#89a3b7',
    textTransform: 'uppercase',
    letterSpacing: '0.12em',
    fontSize: '0.68rem',
    fontWeight: 800,
  },

  serviceMetaValue: {
    color: '#f8fdff',
    fontWeight: 700,
    lineHeight: 1.45,
    fontSize: '0.9rem',
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  serviceDeliverables: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },

  deliverableChip: {
    background: 'rgba(0, 212, 170, 0.1) !important',
    color: '#d8fdf4 !important',
    border: '1px solid rgba(0, 212, 170, 0.18)',
    fontSize: '0.72rem',
    fontWeight: 700,
  },

  toolChipRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },

  toolChip: {
    background: 'rgba(255, 255, 255, 0.04) !important',
    color: '#dce7f1 !important',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    fontSize: '0.72rem',
    fontWeight: 700,
  },

  detailsButton: {
    marginTop: 'auto',
    background: 'linear-gradient(135deg, #00d4aa 0%, #00f0c8 52%, #19b7e6 100%)',
    color: '#06111f !important',
    fontWeight: 800,
    padding: theme.spacing(1.45, 2.5),
    borderRadius: '14px',
    textTransform: 'none',
    boxShadow: '0 18px 44px rgba(0, 212, 170, 0.28)',
    '&:hover': {
      boxShadow: '0 24px 56px rgba(0, 212, 170, 0.38)',
      transform: 'translateY(-2px)',
    },
  },

  processSection: {
    marginBottom: theme.spacing(10),
  },

  processFlow: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },

  processNode: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    paddingTop: theme.spacing(3.5),
    [theme.breakpoints.down('sm')]: {
      flex: 'none',
      width: '100%',
    },
  },

  processCard: {
    width: '100%',
    flex: 1,
    padding: theme.spacing(3, 2.25, 2.5),
    paddingTop: theme.spacing(5),
    borderRadius: '22px',
    background: 'linear-gradient(180deg, rgba(13, 27, 47, 0.92) 0%, rgba(8, 17, 31, 0.86) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 20px 48px rgba(0, 0, 0, 0.22)',
    textAlign: 'center',
    transition: 'transform 240ms ease, box-shadow 240ms ease, border-color 240ms ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      borderColor: 'rgba(0, 212, 170, 0.28)',
      boxShadow: '0 26px 64px rgba(0, 0, 0, 0.28)',
    },
  },

  processStep: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 2,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #00d4aa 0%, #19b7e6 100%)',
    color: '#06111f',
    fontWeight: 900,
    fontSize: '1.05rem',
    letterSpacing: '0.04em',
    border: '4px solid #0a1729',
    boxShadow: '0 14px 30px rgba(0, 212, 170, 0.35)',
  },

  processTitle: {
    color: '#f8fdff',
    marginBottom: theme.spacing(1),
    fontWeight: 800,
    fontSize: '1.2rem',
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
  },

  processText: {
    color: '#b5c3d3',
    lineHeight: 1.7,
    fontSize: '0.92rem',
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  processIndex: {
    display: 'block',
    marginBottom: theme.spacing(1.2),
    color: '#7fcfc0',
    fontSize: '0.72rem',
    fontWeight: 800,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
  },

  processConnector: {
    flex: '0 0 auto',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    paddingTop: theme.spacing(3.5),
    minWidth: 28,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      minWidth: 0,
      height: 32,
      width: '100%',
    },
  },

  processConnectorLine: {
    position: 'absolute',
    top: 'calc(36px - 1px)',
    left: '-4px',
    right: '-4px',
    height: 2,
    background: 'linear-gradient(90deg, rgba(0, 212, 170, 0.5) 0%, rgba(25, 183, 230, 0.5) 100%)',
    borderRadius: 2,
    [theme.breakpoints.down('sm')]: {
      top: 0,
      bottom: 0,
      left: '50%',
      right: 'auto',
      width: 2,
      height: '100%',
      background: 'linear-gradient(180deg, rgba(0, 212, 170, 0.5) 0%, rgba(25, 183, 230, 0.5) 100%)',
      transform: 'translateX(-50%)',
    },
  },

  processConnectorArrow: {
    position: 'relative',
    zIndex: 1,
    color: '#19b7e6',
    fontSize: '1.6rem',
    fontWeight: 900,
    lineHeight: 1,
    marginTop: 22,
    textShadow: '0 0 12px rgba(0, 212, 170, 0.4)',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      transform: 'rotate(90deg)',
    },
  },

  contactSection: {
    marginBottom: theme.spacing(4),
  },

  contactIntroCard: {
    height: '100%',
    padding: theme.spacing(3),
    borderRadius: '24px',
    background: 'linear-gradient(180deg, rgba(13, 27, 47, 0.94) 0%, rgba(8, 17, 31, 0.9) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 24px 70px rgba(0, 0, 0, 0.28)',
    backdropFilter: 'blur(16px)',
  },

  contactChip: {
    background: 'rgba(0, 212, 170, 0.12) !important',
    color: '#86f8e1 !important',
    border: '1px solid rgba(0, 212, 170, 0.22)',
    fontWeight: 800,
    marginBottom: theme.spacing(2),
  },

  contactTitle: {
    color: '#f8fdff',
    fontWeight: 800,
    lineHeight: 1.08,
    marginBottom: theme.spacing(1.5),
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
  },

  contactText: {
    color: '#b5c3d3',
    lineHeight: 1.8,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  contactPills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1, 1),
    marginTop: theme.spacing(2.5),
  },

  contactMiniChip: {
    background: 'rgba(255, 255, 255, 0.05) !important',
    color: '#dce7f1 !important',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    fontWeight: 700,
  },

  contactFormCard: {
    borderRadius: '24px',
    padding: theme.spacing(2.5),
    background: 'linear-gradient(180deg, rgba(13, 27, 47, 0.94) 0%, rgba(8, 17, 31, 0.9) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 24px 70px rgba(0, 0, 0, 0.28)',
  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(1, 6, 13, 0.72)',
    backdropFilter: 'blur(10px)',
  },

  modalContent: {
    width: 'min(760px, calc(100vw - 32px))',
    maxHeight: '88vh',
    overflowY: 'auto',
    borderRadius: '26px',
    outline: 'none',
    background: 'linear-gradient(180deg, rgba(11, 22, 38, 0.98) 0%, rgba(8, 17, 31, 0.98) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 35px 120px rgba(0, 0, 0, 0.45)',
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.04)',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'linear-gradient(180deg, #00d4aa 0%, #19b7e6 100%)',
      borderRadius: 999,
    },
  },

  modalHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  },

  categoryBadge: {
    background: 'rgba(0, 212, 170, 0.12) !important',
    color: '#86f8e1 !important',
    border: '1px solid rgba(0, 212, 170, 0.22)',
    fontWeight: 800,
    marginBottom: theme.spacing(1),
  },

  modalTitle: {
    color: '#f8fdff',
    fontWeight: 800,
    lineHeight: 1.15,
    fontSize: '1.9rem',
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },

  closeButton: {
    color: '#d6e4ef',
    minWidth: 44,
    minHeight: 44,
    borderRadius: '12px',
    transition: 'background 220ms ease, transform 220ms ease',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.06)',
      transform: 'rotate(90deg)',
    },
  },

  modalBody: {
    padding: theme.spacing(3),
    background: 'linear-gradient(180deg, rgba(8, 17, 31, 0.88) 0%, rgba(10, 21, 37, 0.9) 100%)',
  },

  modalDescription: {
    color: '#c2d2e0',
    lineHeight: 1.85,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
    marginBottom: theme.spacing(2.5),
  },

  modalMetrics: {
    marginBottom: theme.spacing(2.5),
  },

  modalMetricCard: {
    padding: theme.spacing(1.8),
    borderRadius: '18px',
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.03) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },

  modalMetricLabel: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    color: '#89a3b7',
    textTransform: 'uppercase',
    letterSpacing: '0.12em',
    fontSize: '0.68rem',
    fontWeight: 800,
  },

  modalMetricValue: {
    color: '#f8fdff',
    fontWeight: 700,
    lineHeight: 1.45,
    fontSize: '0.95rem',
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  toolsSection: {
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(2.4),
    borderRadius: '20px',
    background: 'rgba(255, 255, 255, 0.03)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },

  toolsTitle: {
    color: '#f8fdff',
    fontWeight: 800,
    fontSize: '1.05rem',
    marginBottom: theme.spacing(1.5),
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
  },

  toolsGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },

  toolChipLarge: {
    background: 'rgba(0, 212, 170, 0.1) !important',
    color: '#d8fdf4 !important',
    border: '1px solid rgba(0, 212, 170, 0.18)',
    fontWeight: 700,
  },

  deliverablesSection: {
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(2.4),
    borderRadius: '20px',
    background: 'rgba(255, 255, 255, 0.03)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },

  deliverableTitle: {
    color: '#f8fdff',
    fontWeight: 800,
    fontSize: '1.05rem',
    marginBottom: theme.spacing(1.5),
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
  },

  deliverablesList: {
    margin: 0,
    paddingLeft: theme.spacing(2.5),
    color: '#c2d2e0',
    '& li': {
      marginBottom: theme.spacing(0.8),
      lineHeight: 1.7,
      fontFamily: '"Montserrat", "Segoe UI", sans-serif',
    },
  },

  requestQuoteButton: {
    background: 'linear-gradient(135deg, #00d4aa 0%, #00f0c8 48%, #19b7e6 100%)',
    color: '#06111f !important',
    fontWeight: 800,
    padding: theme.spacing(1.7, 3),
    borderRadius: '14px',
    textTransform: 'none',
    boxShadow: '0 18px 45px rgba(0, 212, 170, 0.28)',
    '&:hover': {
      boxShadow: '0 24px 60px rgba(0, 212, 170, 0.38)',
      transform: 'translateY(-2px)',
    },
  },

  simpleServiceCard: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3.25, 3, 2.75),
    paddingTop: theme.spacing(3.75),
    borderRadius: '22px',
    background: 'linear-gradient(180deg, rgba(15, 30, 52, 0.92) 0%, rgba(7, 16, 29, 0.92) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.07)',
    boxShadow: '0 18px 44px rgba(0, 0, 0, 0.22)',
    backdropFilter: 'blur(14px)',
    overflow: 'hidden',
    textAlign: 'left',
    transition: 'transform 280ms ease, box-shadow 280ms ease, border-color 280ms ease',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      padding: 1,
      background: 'linear-gradient(180deg, rgba(0, 212, 170, 0.0) 0%, rgba(0, 212, 170, 0.0) 100%)',
      WebkitMask:
        'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
      pointerEvents: 'none',
      transition: 'background 280ms ease',
    },
    '&:hover': {
      transform: 'translateY(-6px)',
      borderColor: 'rgba(0, 212, 170, 0.32)',
      boxShadow: '0 32px 72px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(0, 212, 170, 0.06)',
      '& $serviceCardAccent': {
        opacity: 1,
        transform: 'scaleX(1)',
      },
      '& $learnMoreArrow': {
        transform: 'translateX(4px)',
      },
    },
  },

  serviceCardAccent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 3,
    background: 'linear-gradient(90deg, #00d4aa 0%, #19b7e6 100%)',
    opacity: 0.55,
    transform: 'scaleX(0.4)',
    transformOrigin: 'left center',
    transition: 'opacity 280ms ease, transform 380ms cubic-bezier(0.22, 1, 0.36, 1)',
    borderRadius: '22px 22px 0 0',
  },

  simpleServiceContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: '100%',
  },

  simpleServiceHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(0.25),
  },

  simpleServiceTitle: {
    color: '#f8fdff',
    fontWeight: 800,
    lineHeight: 1.28,
    fontSize: '1.3rem',
    letterSpacing: '-0.01em',
    fontFamily: '"vester-medium", "Montserrat", sans-serif',
    margin: 0,
  },

  serviceMetaPills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75, 0.75),
    marginTop: theme.spacing(0.75),
  },

  serviceMetaPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.6, 0.6),
    padding: theme.spacing(0.4, 1.1),
    borderRadius: '999px',
    background: 'rgba(255, 255, 255, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    color: '#c8d6e3',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.01em',
    lineHeight: 1.4,
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
    whiteSpace: 'nowrap',
  },

  serviceMetaPillDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #00d4aa 0%, #19b7e6 100%)',
    boxShadow: '0 0 8px rgba(0, 212, 170, 0.6)',
    flexShrink: 0,
  },

  serviceMetaPillAccent: {
    background: 'rgba(0, 212, 170, 0.12)',
    border: '1px solid rgba(0, 212, 170, 0.28)',
    color: '#86f8e1',
  },

  simpleServiceDescription: {
    color: '#aebccc',
    lineHeight: 1.7,
    fontSize: '0.93rem',
    fontFamily: '"Montserrat", "Segoe UI", sans-serif',
  },

  simpleServiceFeatures: {
    marginTop: theme.spacing(0.25),
    padding: theme.spacing(1.6, 1.5, 1.4),
    borderRadius: '14px',
    background: 'rgba(255, 255, 255, 0.025)',
    border: '1px solid rgba(255, 255, 255, 0.06)',
  },

  featuresLabel: {
    display: 'block',
    color: '#86f8e1',
    fontWeight: 800,
    fontSize: '0.7rem',
    letterSpacing: '0.14em',
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
  },

  featuresList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'grid',
    gap: theme.spacing(0.65),
    textAlign: 'left',
    '& li': {
      position: 'relative',
      paddingLeft: theme.spacing(2.6),
      textAlign: 'left',
      color: '#cad8e6',
      lineHeight: 1.55,
      fontSize: '0.88rem',
      fontFamily: '"Montserrat", "Segoe UI", sans-serif',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '0.32em',
        width: 14,
        height: 14,
        borderRadius: '50%',
        background: 'rgba(0, 212, 170, 0.14)',
        border: '1px solid rgba(0, 212, 170, 0.45)',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 4,
        top: '0.55em',
        width: 6,
        height: 3,
        borderLeft: '1.5px solid #00f0c8',
        borderBottom: '1.5px solid #00f0c8',
        transform: 'rotate(-45deg)',
      },
    },
  },

  serviceCardFooter: {
    marginTop: 'auto',
    paddingTop: theme.spacing(1.75),
    borderTop: '1px solid rgba(255, 255, 255, 0.06)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  learnMoreButton: {
    color: '#86f8e1 !important',
    fontWeight: 700,
    padding: theme.spacing(0.5, 0),
    minWidth: 0,
    borderRadius: 0,
    textTransform: 'none',
    fontSize: '0.92rem',
    letterSpacing: '0.01em',
    background: 'transparent !important',
    '& .MuiButton-label': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(0.9),
    },
    '&:hover': {
      background: 'transparent !important',
      color: '#aaf9e6 !important',
    },
  },

  learnMoreArrow: {
    display: 'inline-block',
    fontSize: '1rem',
    lineHeight: 1,
    transition: 'transform 260ms cubic-bezier(0.22, 1, 0.36, 1)',
  },
}));

export default useDigitalMediaStyles;